import PropTypes from 'prop-types'
import { Button } from '@chakra-ui/react'
import {
  faAngleLeft,
  faAngleRight,
  faEllipsisH,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { Fragment, useCallback } from 'react'

const PageButton = ({
  children,
  disabled,
  isCurrent,
  value,
  handlePageClick,
}) => {
  const onChangePage = useCallback(() => {
    handlePageClick(value)
  }, [])
  return (
    <Button
      borderRadius="3px"
      w="32px"
      h="32px"
      variant={isCurrent ? 'primary' : 'white'}
      _hover={{
        backgroundColor: 'gray',
        color: 'white',
        cursor: 'pointer',
      }}
      padding="2px"
      border={'transparent'}
      disabled={disabled}
      onClick={onChangePage}
    >
      {children}
    </Button>
  )
}

PageButton.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  handlePageClick: PropTypes.func,
  isCurrent: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

const Page = ({ currentPage, lastPage, handlePageClick }) => {
  const render = []
  if (Number(currentPage) >= 0) {
    const prevPage = Number(currentPage) - 1
    render.push(
      <PageButton
        handlePageClick={handlePageClick}
        key={`prev-page-${prevPage}`}
        disabled={currentPage === 1}
        value={prevPage}
      >
        <FontAwesomeIcon icon={faAngleLeft} />
      </PageButton>,
    )
  }

  let startIdx
  let endIdx
  if (Number(lastPage) < 8) {
    startIdx = 0
    endIdx = Number(lastPage)
  } else {
    if (Number(currentPage) === 1 && Number(lastPage) === 1) {
      startIdx = 0
      endIdx = 1
    } else if (Number(currentPage) + 3 >= lastPage) {
      startIdx = lastPage - 8
      endIdx = lastPage
    } else if (Number(currentPage) > 1) {
      startIdx = Number(currentPage) - (currentPage < 3 ? 2 : 3)
      endIdx = startIdx + 8
    } else if (Number(currentPage) - 1 >= 0) {
      startIdx = Number(currentPage) - 1
      endIdx = startIdx + 8
    } else {
      startIdx = 0
      endIdx = 5
    }
  }

  for (let idx = startIdx; idx < endIdx; idx++) {
    const offset = idx + 1

    render.push(
      <PageButton
        handlePageClick={handlePageClick}
        isCurrent={offset === currentPage}
        value={offset}
        key={`page-${offset}`}
      >
        {offset}
      </PageButton>,
    )
  }

  if (endIdx < lastPage) {
    render.push(
      <Fragment key={`last-page-${lastPage - 1}`}>
        <FontAwesomeIcon icon={faEllipsisH} color="gray" />
        <PageButton
          handlePageClick={handlePageClick}
          value={lastPage - 1}
          key={`last-page-${lastPage - 1}`}
        >
          {lastPage - 1}
        </PageButton>
      </Fragment>,
    )
    render.push(
      <Fragment key={`last-page-${lastPage}`}>
        <PageButton
          handlePageClick={handlePageClick}
          value={lastPage}
          key={`last-page-${lastPage}`}
        >
          {lastPage}
        </PageButton>
      </Fragment>,
    )
  }

  if (Number(currentPage) < lastPage + 1) {
    const nextPage = Number(currentPage) + 1
    render.push(
      <PageButton
        handlePageClick={handlePageClick}
        value={nextPage}
        key={`next-page-${nextPage}`}
        disabled={currentPage === lastPage}
      >
        <FontAwesomeIcon icon={faAngleRight} />
      </PageButton>,
    )
  }
  return render
}

export default Page
